import { staticDispatch } from 'reduxState/store';
import { ReduxActions } from 'reduxState/storeCore';

// Note: Older Safari doesn't support
// https://stackoverflow.com/questions/57700474/how-can-i-use-the-broadcastchannel-api-or-something-similar-in-safari-10
const reduxChannel = window?.BroadcastChannel
  ? new window.BroadcastChannel('idex:redux-actions')
  : undefined;

export const sendReduxActionToOtherTabs = (action: ReduxActions) => {
  if (!reduxChannel) {
    console.warn('sendToOtherTabs: Missing channel support');
    return;
  }
  if ((action as any).__crossTabEvent === true) {
    // Prevent just received events to be re-dispatched
    return;
  }
  reduxChannel.postMessage({
    ...action,
    __crossTabEvent: true,
  });
};

if (reduxChannel) {
  reduxChannel.onmessage = (event: MessageEvent<ReduxActions>) => {
    staticDispatch(event.data);
  };
}

// Below is unused code to sync state using local storage directly

// https://stackoverflow.com/questions/28230845/communication-between-tabs-or-windows

// import { CACHE_ID, loadState } from 'reduxState/caching';
// import { staticDispatch, ReduxState, ReduxActions } from 'reduxState/store';
// import { reHydrateStateOfPendingDeposits } from 'reduxState/balances/pendingDeposits';
// import { changeUser } from './currentUser/currentUserReducer';
// function objectsNotEqual<A, B>(a: A, b: B) {
//   return JSON.stringify(a) !== JSON.stringify(b);
// }

// function messageReceive(event: StorageEvent, getState: () => ReduxState) {
//   if (event.key !== CACHE_ID || !event.newValue) {
//     return;
//   }
//   console.debug('CROSS_TAB_Event:', event.newValue);
//   const partialState = loadState(event.newValue);
//   if (!partialState) {
//     return;
//   }

//   const currentState = getState();

//   const currentPendingDeposits = currentState.balances?.pendingDeposits;
//   const newPendingDeposits = partialState.balances?.pendingDeposits;
//   if (
//     newPendingDeposits &&
//     (newPendingDeposits.updated || 0) > (currentPendingDeposits.updated || 0) &&
//     objectsNotEqual(
//       currentPendingDeposits.pendingMap,
//       newPendingDeposits.pendingMap
//     )
//   ) {
//     console.debug('Rehydrating pending deposits');
//     staticDispatch(reHydrateStateOfPendingDeposits(newPendingDeposits));
//   }

//   // Wallet is synced using actions
//   // // if (
//   // //   partialState.wallet &&
//   // //   (partialState.wallet?.updated || 0) > (currentState.wallet.updated || 0) &&
//   // //   objectsNotEqual(currentState.wallet, partialState.wallet)
//   // // ) {
//   // //   console.debug('Rehydrating wallet');
//   // //   staticDispatch(reHydrateStateOfWallet(partialState.wallet));
//   // // }
// }

// export const startListeningOnCrossTabChanges = (getState: () => ReduxState) => {
//   window.addEventListener('storage', event => messageReceive(event, getState));
// };
